import React from 'react';
import styles from './QuantityPicker.m.sass';


export default class QuantityPicker extends React.PureComponent {
  increment = () => {
    const {value, onChange} = this.props;

    onChange(value + 1);
  };

  decrement = () => {
    const {value, onChange} = this.props;

    onChange(value - 1);
  };

  render() {
    const {value, min, max} = this.props;

    return (
      <div className={styles.quantity}>
        <div className={styles.quantity_wrapper}>
          <button
            className={styles.quantity_button}
            onClick={this.decrement}
            disabled={value <= min}
          >
            &minus;
          </button>
          <input
            className={styles.quantity_input}
            type="text"
            value={value}
            readOnly
          />
          <button
            className={`${styles.quantity_button} ${styles.quantity_button__right}`}
            onClick={this.increment}
            disabled={value >= max}
          >
            &#43;
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productPurchase/quantityPicker/QuantityPicker.js